import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef, Inject,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  Self,
  SimpleChanges
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ValidationErrors,
  Validator
} from "@angular/forms";
import * as _ from "lodash";

require("./bringoz-service-time-input.scss");
@Component({
  standalone: false,
  selector: "app-bringoz-service-time-input",
  templateUrl: './bringoz-service-time-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozServiceTimeInputComponent
  implements OnInit, OnChanges, ControlValueAccessor, Validator {
  @Input() ngPlaceholder: string = "";
  @Input() serviceTime: number | null = null;
  @Input() isDisabled: boolean;
  @Input() required: boolean = false;
  @Input() minValue: number | null;
  @Output() onChange = new EventEmitter<number | null>();


  serviceTimeInMinutes: number | null = null;
  private factor = 60000;

  public ngControl: any;

  constructor(@Optional() @Self() @Inject(NgControl) private control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
      this.ngControl = this.control;
    }
  }

  ngOnInit(): void {
    this.syncMinutesFromServiceTime();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.serviceTime && !changes.serviceTime.isFirstChange()) {
      this.syncMinutesFromServiceTime();
    }
  }

  onChangeValue(value: any): void {

    if (value === "" || value === undefined || value === null) {
      this.serviceTimeInMinutes = null;
      this.serviceTime = null;
      this.emitChange(null);
    } else {
      const minutes = _.toNumber(value);
      this.serviceTimeInMinutes = minutes;
      this.serviceTime = minutes * this.factor;
      this.emitChange(this.serviceTime);
    }

    if (this.control?.control) {
      this.control.control.setErrors(this.validate());
    }
  }

  writeValue(value: number | null): void {
    if (value === undefined || value === null) {
      this.serviceTime = null;
      this.serviceTimeInMinutes = null;
    } else {
      this.serviceTime = value;
      this.serviceTimeInMinutes = Math.round(value / this.factor);
    }
  }

  onModelChange: (value: any) => void = () => {
  };
  onModelTouched: () => void = () => {
  };

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  validate(): ValidationErrors | null {
    const value = this.serviceTime;

    if (this.required && (value === null || value === undefined)) {
      return {required: true};
    }

    if (value !== null && value !== undefined && this.minValue !== null && this.minValue !== undefined
    ) {
      const timeInMinutes = Math.round(value / this.factor);
      if (timeInMinutes < this.minValue) {
        return {min: {min: this.minValue, actual: timeInMinutes}};
      }
    }

    return null;
  }

  private syncMinutesFromServiceTime(): void {
    if (this.serviceTime !== null && this.serviceTime !== undefined) {
      this.serviceTimeInMinutes = Math.round(this.serviceTime / this.factor);
    } else {
      this.serviceTimeInMinutes = null;
    }
  }

  private emitChange(value: number | null): void {
    this.onChange.emit(value); // external binding
    this.onModelChange(value); // forms API
    this.onModelTouched();
  }
}
